import {useConfig} from '@aboutyou/config';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useTranslation} from '@aboutyou/i18n';
import {useMemo} from 'react';

const ADJUST_TRACKER_TOKEN = '1cj3nxtn';

export const useOutletLinkConfig = (
  campaignName: 'metabar_desktop' | 'catNav_mWeb',
) => {
  const {isActive: showOutletLink} = useIsFeatureActive('show_outlet_link');
  const {t} = useTranslation();
  const {ayOutletUrl} = useConfig();
  const outletLabel = t('Outlet');

  const url = useMemo(() => {
    if (!ayOutletUrl) {
      return '';
    }

    const baseUrl = new URL(ayOutletUrl);
    baseUrl.searchParams.set('utm_source', 'aboutyou');
    baseUrl.searchParams.set('utm_medium', 'shop');
    baseUrl.searchParams.set('utm_campaign', campaignName);
    baseUrl.searchParams.set('adj_t', ADJUST_TRACKER_TOKEN);
    baseUrl.searchParams.set('adj_campaign', campaignName);

    return baseUrl.toString();
  }, [ayOutletUrl]);

  return {
    outletLabel,
    ayOutletUrl: url,
    showOutletLink,
  };
};
